export const CHANGE_SYNTH_PARAM = "CHANGE_SYNTH_PARAM";